<template>
  <div style="height: 100%;width: 100%;overflow: hidden;" :style="bgfillSet(data.bgfllStyle || data.bgfillStyle,data.transparentBackground)">
    <AnimateModule :class="['text-cpn', 'textAreaHou', data.transparentBackground ? 'bTransparent' : '',  data.projectionTransparent ? 'pTransparent' : '', isEdit ? 'edit-box' : '']" :config="data.animateConfig" :disabled="data.animate !== 'open'">
      <!-- 数据源模式 -->
      <template v-if="data.dataSource && data.dataSource.isData">
        <template v-if="isShow">
          <!-- 数据切换模式 -->
          <template v-if="data.dataSource.isChange">
            <!-- 页数 -->
            <el-carousel 
              :interval="5000"
              :autoplay="data.dataSource.changeMode === 0 ? true : false"
              :arrow="formData.length > 1 ? 'hover' : 'never'"
            >
              <el-carousel-item v-for="(formDataItem, formDataIndex) in formData" :key="formDataIndex">
                <div class="edit-form" v-if="!disabled && isEdit">
                  <i class="iconfont icon-bianji" @click="openEdit(formDataItem)"></i>
                </div>
                <div v-for="(item, index) in data.dataSource.appInfo.fieldList" :key="index">
                  <richTextView
                    v-if="item.type === 'richTextWid' && formData[`${item.title}_${item.type}`]"
                    :html="getText(formData[`${item.title}_${item.type}`])" />
                  <div
                    v-else
                    type="textarea"
                    style="white-space: pre-line;line-height: 24px;padding: 10px 8px;"
                  >{{formDataItem[`${item.title}_${item.type}`]||'&nbsp;'}}</div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </template>
          <!-- 数据不切换 -->
          <template v-else>
            <div class="edit-form" v-if="!disabled && isEdit">
              <i class="iconfont icon-bianji" @click="openEdit(formData)"></i>
            </div>
            <div v-for="(item, index) in data.dataSource.appInfo.fieldList" :key="index">
              <richTextView
                v-if="item.type === 'richTextWid' && formData[`${item.title}_${item.type}`]"
                :html="getText(formData[`${item.title}_${item.type}`])" />
              <div
                v-else
                type="textarea"
                style="white-space: pre-line;line-height: 24px;padding: 10px 8px;"
              >{{formData[`${item.title}_${item.type}`]||'&nbsp;'}}</div>
            </div>
          </template>
        </template>
      </template>
      <template v-else-if="data.bindinf">
        <richTextView :html="getText(data.bindinf)" />
      </template>
    </AnimateModule>
    <!-- 修改 -->
    <form-edit ref="formEdit" @editSubmit="editCallBack"></form-edit>
  </div>
</template>

<script>
import { dealText } from '@/api/common.js'
import { getopenreportformlist, getapifielddatalist } from '@/port/clientSide/workbench.js'
import { getuserfielddatalist } from '@/port/clientSide/applicationRouting'
import { getapprovallimit } from '@/port/clientSide/oaExamineAudit.js'
import AnimateModule from "@/components/schoolInstrument/common/animateModule.vue";
import { defineAsyncComponent } from 'vue';
export default {
  name: 'textCpn',
  data() {
    return {
      formData: {},
      disabled: false,
      isEdit: false,
      isShow: false,
      isShowRichText: true,
      spaceid:this.$route.query.spaceid,
      commonUseData: [
        '当前日期', '昨天日期', '明天日期', '当前年份', '下周时间段', '当前星期', '当前上午/下午', '当前月份', '学年',
        '学期', '上下学期', '当前用户'
      ],
    }
  },
  components: {
    richTextView: defineAsyncComponent(() => import('@/components/common/richTextView.vue')),
		formEdit: defineAsyncComponent(() => import('../formEdit.vue')),
    AnimateModule,
  },
  watch: {
    'data.dataSource.isData': {
      handler (val) {
        if (val) {
          this.getData()
        }
      },
      immediate: true,
    },
    'data.dataSource.isChange': {
      handler () {
        if (this.data.dataSource && this.data.dataSource.isData) {
          this.getData()
        }
      },
      immediate: true,
    },
    'data.bindinf': {
      handler () {
        this.isShowRichText = false
        this.$nextTick(()=>{
          this.isShowRichText = true
        })
      },
    }
  },
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    },
    //- 当前组件序号
    index: {
      type: Number
    },
    isDoor: {
      type: Boolean,
      default: false
    },
    id: {}
  },
  methods: {
    getText (text) {
      const customData = this.isDoor ? this.$store.state.doorCustomData : 
        this.$store.state.dashboardCustomDataObj[this.id] || this.$store.state.dashboardCustomData
      const res = dealText({ 
        text, 
        commonData: this.$store.state.userData, 
        customData, 
        functionParms: this.data.functionParms 
      })
      return res || text
    },
    // 背景填充设置
    bgfillSet(bgfllStyle,transparentBackground){
      if(bgfllStyle && !transparentBackground){
        let fillstyle = {}
        if(bgfllStyle.bgstyle === 'picture'){
          // 背景填充图片
          if(bgfllStyle.picture.layout === 'default'){
            // 原大小填充
            fillstyle.background = `url('${this.$imgurl + bgfllStyle.picture.url}') no-repeat`
          }else if(bgfllStyle.picture.layout === 'adaption'){
            // 自适应填充
            fillstyle.background = `url('${this.$imgurl + bgfllStyle.picture.url}') no-repeat`
            fillstyle.backgroundSize = '100% 100%'
          }
        }else if(bgfllStyle.bgstyle === 'color'){
          // 背景填充颜色
          fillstyle.backgroundColor = bgfllStyle.color
        }
        return fillstyle
      }else{
        return ''
      }
    },
    // 修改表单内容
    openEdit (val) {
      this.$refs.formEdit.open({
        appData: this.data,
        formData: val,
      })
    },
    // 操作
    handleSet(key) {
      switch (key) {
        case 'hide': {
          this.$emit('handle', {
            status: 'show',
            item: this.data,
            index: this.index
          })
          break;
        }
        case 'del': {
          this.$emit("handle", {
            status: 'delete',
            index: this.index
          });
          break;
        }
        case 'cpoy': {
          this.$emit("handle", {
            status: 'copy',
            item: this.data
          });
          break;
        }
        case 'set': {
          this.$refs.textSet.open(this.data)
          break;
        }
        case 'edit': {
          this.$emit("handle", {
            status: 'edit',
            index: this.index
          });
          break;
        }
        case 'editDrid': {
          this.$emit("handle", {
            status: 'editDrid',
            index: this.index
          });
          break;
        }
      }
    },
    // 文本修改回调
    editCallBack () {
      this.isShow = !this.isShow
      this.getData()
      this.$nextTick(() => {
        this.isShow = !this.isShow
      })
    },
    // 获取内容
    async getData () {
      const query = {
        curpage: 0,
        pagesize: 0,
        approvalId: this.data.dataSource.appInfo.app.appId
      }
      const iId = this.data.dataSource.appInfo.app.iId
      if (this.$route.query.space || this.$route.query.spaceid) {
        query.spaceid = this.$route.query.spaceid || localStorage.getItem('spaceid')
      }
      else if (this.$route.query.upace || this.$route.query.upaceid) {
        query.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }
      const { code, data } = await getopenreportformlist(query)
      if (code === 0) {
        const reportFormId = data[0].reportFormId
        const query = {
          type: 0,
          curpage: 0,
          pagesize: 50,
          cateId: -1,
          reportFormId,
          approvalId: this.data.dataSource.appInfo.app.appId
        }
        const template = JSON.parse(data[0].userReport.content)
        const res = iId === 1 ? await getuserfielddatalist(query) : await getapifielddatalist(query)
        if (res.code === 0 && res.data.length > 0) {
          if (this.data.dataSource.isChange) {
            const formDataList = []
            for (let index = 0; index < res.data.length; index++) {
              const item = res.data[index];
              const formData = {
                approvingId: item.approvingId
              }
              template.forEach(iter => {
                formData[`${iter.title}_${iter.type}`] = item[iter.title] 
              })
              formDataList.push(formData)
              if (formDataList.length >= this.data.dataSource.scrollNum) break;
            }
            this.formData = JSON.parse(JSON.stringify(formDataList))
          } else {
            const formData = {
              approvingId: res.data[0].approvingId
            }
            template.forEach(item => {
              formData[`${item.title}_${item.type}`] = res.data[0][item.title] 
              
            })
            this.formData = JSON.parse(JSON.stringify(formData))
          }
        }
      }
    },
    async getlimits() {
      const query = {
        appid: this.data.dataSource.appInfo.app.appId,
      }
      const { code, data } = await getapprovallimit(query)
      if (code === 0) {
        if (this.data.dataSource.appInfo.app.iId == 1) { // 个人数据
          this.isEdit = data.updatemyreportform || false
          this.isShow = data.myreportform || false
        } else {
          this.isEdit = data.updatereportform || false
          this.isShow = data.reportform || false
        }
      }
    }
  },
  async mounted () {
    if (this.$route.path.search('admins') !== -1) {
      this.disabled = true
      this.isShow = true
    } else {
      if (this.data.dataSource && this.data.dataSource.isData) {
        this.getlimits()
      }
    }
  },

}
</script>


<style scoped lang="scss">
  .text-cpn {
    padding: 0 11px;
    height: 100%;
    position: relative;
    overflow-y: scroll;
    :deep(.el-button) {
      width: 40px;
      height: 40px;
      padding: 6px;
      background: #4e86ff;
      .iconfont {
        font-size: 22px;
      }
    }
    .edit-form {
      position: absolute;
      right: 8px;
      top: 8px;
      cursor: pointer;
      z-index: 9;
    }
    .no-list {
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .no-list-title {
        line-height: 40px;
        font-size: 16px;
        color: #4e86ff;
      }
    }
    &:hover .set-mask {
      display: flex;
    }

    .set-mask {
      z-index: 99;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: none;
      align-items: center;
      justify-content: center;
      
      &-btn {
        color: #ffffff;
        i {
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
  }
  .edit-box{
    :deep(.el-carousel__item) {
      padding-right: 15px;
      box-sizing: border-box;
    }
  }
  :deep(.el-carousel) {
    height: 100%;
    .el-carousel__container {
      height: 100%;
    }
  }
  .bTransparent {
  background: transparent !important;
  }
  .pTransparent {
  box-shadow: none !important;
  border-color: transparent !important;
  }
  .textArea, .textAreaHou {
  width: 100% !important;
  padding: 0 !important;
  }
</style>